import { useBreakpoint } from "gatsby-plugin-breakpoints";
import { Link } from 'gatsby';
import React from 'react';

import CrabsLogo from '../assets/crabs-logo.svg'
import ShrimpCiabLogo from '../assets/crabs-logo-shrimpocalypse.svg'
import shrimpLogo from '../images/shrimpocalypse.webp'

const Logo = ({ theme }) => {
  const breakpoints = useBreakpoint();

  return (
    <Link
      aria-label='Homepage'
      to={theme === "shrimpocalypse" ? "/shrimpocalypse" : "/"}
      className="block"
    >
      { !breakpoints.sm && (
        theme === "shrimpocalypse" ?
        <div
          className='
            z-20
            h-20
            flex
            p-2
            justify-center
          '
        >
            <ShrimpCiabLogo className="py-2" />
            <img src={shrimpLogo} alt="" srcset="" className="pt-[5px] block" />
        </div>
        :
          <CrabsLogo className="w-full" />
      )
      }
    </Link>
  );
}

export default Logo;